export default __webpack_public_path__ + "static/media/splunk.8071f5b1.svg";